import { useParams } from 'react-router-dom';

import { createConsoleUrl } from '../utils/console';
import { Loader } from '../components/loader';

export const MediaLibrary = () => {
  const { customerId } = useParams();
  // TODO: Get AppId from remote application wrapper context
  const searchParams = { 'cld-target-product': 'digital_asset_management' };
  // TODO: Use redirectDocument from react-router@6.15
  window.location.replace(createConsoleUrl('media_library', customerId, searchParams));
  return <Loader />;
};
